import React from 'react';
import 'react-modal-video/scss/modal-video.scss';
import ContactModal from "../../components/ContactModal";

function Block1() {

    return (
            <section className="about-section-two style-two layout-pt-60 layout-pb-60 js-tab-menu-content">
                <div className="auto-container">
                    <div className="row grid-base align-items-center g-5">
                        <div className="content-column -no-margin col-xl-5 col-lg-6 col-md-12 col-sm-12 wow fadeInRight">
                            <div className="wow fadeInLeft">
                                <div className="sec-title">
                                    <h2 className="fw-700">De la sensibilisation <span>à l’engagement</span></h2>
                                </div>

                                <div className="text mt-30">
                                    Aujourd’hui, beaucoup d’entreprises souhaitent <b>faire progresser leur politique
                                    handicap</b>, mais manquent de formats <b>concrets, engageants</b> et
                                    <b>mesurables</b> pour embarquer leurs équipes.
                                </div>
                                <div className="text mt-30">
                                    <b>Les Webinaires Talents Handicap</b> apportent une réponse simple et opérationnelle :
                                    <b>des rendez-vous réguliers, utiles, pédagogiques et actionnables</b>, qui transforment
                                    la sensibilisation en dynamique collective
                                </div>
                                <ContactModal textButton="Échangeons sur vos besoins" showText={false} small="small" linkPageContact={false} iframe={false} couleur={false} formModal={true}/>
                            </div>
                        </div>

                        <div className="image-column col-xl-5 offset-xl-2 col-lg-5 offset-lg-1 col-md-12 col-sm-12">
                            <figure className="image-box image-responsive">
                                <img src="/images/resource/discussions.webp" alt="discussions" className="homepage" />
                            </figure>
                        </div>
                    </div>
                </div>
            </section>
    );
}

export default Block1;
